<!-- <ion-header class="borderbottom">
  <ion-toolbar class="primary-color-background">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="header-content">
      <div fxLayout="row" fxLayoutAlign="center center" class="start-buttons m-l-15">
        Address History
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="logo-container">
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="end-buttons m-r-5">
        <ion-button (click)="closeModal()" class="font-size-16" slot="end" fill="clear">
          <ion-icon color="tertiary" slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="white-background">
  <div fxLayout="column" fxLayoutAlign="center center" style="padding: 5px; font-family: Arial, sans-serif;">
    
  </div>
</ion-content> -->


<ion-header class="modal-header" *ngIf="key == 4">
  <ion-toolbar>
    <!-- <ion-title class="p-0 m-0 color-netral-900 inter-bold">{{'self_pwa_text.give_permision_text' |
      translate}}</ion-title> -->
    <ion-title class="m-0 color-netral-900 inter-bold">{{'self_pwa_text.location_not_availble' |
      translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <!-- <ion-icon name="close-circle" class="font-size-26 color-netral-900"></ion-icon> -->
        <i class="bi bi-x"></i>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ng-container *ngIf="steps; else tryAgainGuide">
  <ion-content class="modal-content" *ngIf="key == 4" #content>
    <ion-card style="text-align: left;
    background: #f4f4f4;
    color: #111111;
    font-weight: 400;
    box-shadow: none !important;
    border-radius: 10px;
    border: 1px solid #EEEEEE;">
      <ion-card-content>
        <div fxLayout="row" fxLayoutAlign="start start" style="gap: 5px;">
          <ion-icon name="alert-circle-outline" style="zoom: 3;
          display: flex;
          color: red !important;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: -3px;"></ion-icon>
          <h4 class="font-size-15 color-netral-900">{{'self_pwa_text.location_not_detect' | translate}}</h4>
        </div>
      </ion-card-content>
    </ion-card>
    <div class="inspection-cards-container p-0">
      <div class="tab-container">
        <div class="tab font-size-15 color-netral-900 inter-medium" *ngFor="let tab of tabs; let j=index"
          [class.active]="j == selectedTabIndex" (click)="onTabClick(j)">
          {{tab.tabName}}
        </div>
      </div>
    </div>
    <ion-card class="m-0">
      <ion-card-content>
        <div *ngIf="platform === 'android'">
          <div *ngIf="selectedTabIndex == 0">
            <h2 class="font-size-18 ion-text-left color-netral-900 inter-large m-t-15 m-b-10">
              {{'self_pwa_text.enable_location_text' | translate}}</h2>
            <ion-list lines="none" class="b-r-13 m-t-5 b-1">
              <ion-item>
                <!-- <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-gear me-2"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.open_app_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.settings_text' |
                    translate}}</strong> {{'self_pwa_text.app_text' | translate}}</ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-geo-alt me-2"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.navigate_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.location_text' |
                    translate}}</strong> {{'self_pwa_text.or_text' | translate}} <strong
                    class="color-netral-800 inter-bold">{{'self_pwa_text.privacy_text' | translate}}</strong>
                  {{'self_pwa_text.settings_text' | translate}}.</ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="toggle-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-toggle-on"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.turn_text' |
                  translate}}
                  <strong class="color-netral-800 inter-bold">{{'self_pwa_text.location_text' | translate}}</strong>
                  {{'self_pwa_text.toggle_text' | translate}}
                  <strong class="color-netral-800 inter-bold"> {{'self_pwa_text.on_text' |
                    translate}}</strong>.</ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="compass-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-compass"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.choose_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.high_accuracy_text' |
                    translate}}</strong> {{'self_pwa_text.prompted_text' |
                  translate}}</ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="arrow-back-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-arrow-left"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.return_app_text'
                  |
                  translate}}</ion-label>
              </ion-item>

              <ion-item class="ion-justify-content-center">
                <h4 (click)="toggleGif(0)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 0 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                    }}</u></h4>
              </ion-item>
              <!-- GIF Image (Hidden Initially) -->
              <ion-item *ngIf="showGif && index == 0" class="ion-justify-content-center">
                <img src="../../../assets/images/PermissioGif/first.gif" alt="Enable Location Guide"
                  class="location-gif">
              </ion-item>
            </ion-list>
          </div>

          <div *ngIf="selectedTabIndex == 1">
            <h2 class="font-size-18 ion-text-left color-netral-900 inter-large m-t-15 m-b-10">
              {{'self_pwa_text.allow_permission_text' |
              translate}}</h2>
            <ion-list lines="none" class="b-r-13 m-t-5 b-1">
              <ion-item>
                <!-- <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-gear me-2"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.open_app_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.settings_text' |
                    translate}}</strong> {{'self_pwa_text.app_text' |
                  translate}}</ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="apps-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-grid"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.go_to_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.apps_text' |
                    translate}}</strong> {{'self_pwa_text.or_text' |
                  translate}}
                  <strong class="color-netral-800 inter-bold">{{'self_pwa_text.application_text' |
                    translate}}</strong>.</ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="search-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-search"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.find_app_text' |
                  translate}}</ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="lock-closed-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-lock"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.tap_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.permissions_text' |
                    translate}}</strong>.</ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="locate-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-geo-alt me-2"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.enable_text' |
                  translate}} <strong class="color-netral-800 inter-bold">{{'self_pwa_text.location_text' |
                    translate}}</strong>
                  {{'self_pwa_text.permission_text' |
                  translate}}</ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="arrow-back-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-arrow-left"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.return_app_text'
                  |
                  translate}}</ion-label>
              </ion-item>
              <ion-item class="ion-justify-content-center">
                <h4 (click)="toggleGif(1)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 1 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                    }}</u></h4>
              </ion-item>
              <!-- GIF Item -->
              <ion-item *ngIf="showGif && index == 1" class="ion-justify-content-center">
                <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                <img src="../../../assets/images/PermissioGif/second.gif" alt="Enable Location Guide"
                  class="location-gif">
              </ion-item>
            </ion-list>
          </div>

          <div *ngIf="selectedTabIndex == 2">
            <h2 class="font-size-18 ion-text-left color-netral-900 inter-large m-t-15 m-b-10">
              <span [innerHTML]="highlightWords('self_pwa_text.enableLocationForWebsite' |
            translate)"></span>
            </h2>

            <ion-list lines="none" class="b-r-13 m-t-5 b-1">
              <ion-item>
                <!-- <ion-icon slot="start" name="arrow-back-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-arrow-left"></i>
                <ion-label class="show-fulltext color-netral-600 m-l-3">
                  <span [innerHTML]="highlightWords('self_pwa_text.lookAtLeftSide' |
            translate)"></span>
                </ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="lock-closed-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-lock"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">
                  <span [innerHTML]="highlightWords('self_pwa_text.tapIcon' |
            translate)"></span>
                </ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="toggle-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-toggle-on"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3"><span [innerHTML]="highlightWords('self_pwa_text.toggleLocation' |
              translate)"></span></ion-label>
              </ion-item>
              <ion-item class="ion-justify-content-center">
                <h4 (click)="toggleGif(2)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 2 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                    }}</u></h4>
              </ion-item>
              <!-- GIF Item -->
              <ion-item *ngIf="showGif && index == 2" class="ion-justify-content-center">
                <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                <img src="../../../assets/images/PermissioGif/third.gif" alt="Enable Location Guide"
                  class="location-gif">
              </ion-item>
            </ion-list>
          </div>
        </div>

        <div *ngIf="platform === 'ios'">
          <ng-container *ngIf="browserType === 'Safari'">
            <div *ngIf="selectedTabIndex == 0">
              <h2 class="font-size-18 ion-text-left inter-large color-netral-900 m-t-15 m-b-10">
                <span [innerHTML]="highlightWords('self_pwa_text.enableLocationSafari' |
            translate)"></span>
              </h2>
              <ion-list lines="none" class="b-r-13 m-t-5 b-1">
                <ion-item>
                  <!-- <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-gear me-2"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.openSettings' |
            translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="lock-closed-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-lock"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.tapPrivacySecurity' |
            translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-geo-alt"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.tapLocationServices' |
            translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="globe-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-globe"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.selectSafariWebsites' |
            translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="checkmark-circle-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-check-circle"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.chooseLocationOption' |
            translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item class="ion-justify-content-center">
                  <h4 (click)="toggleGif(0)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 0 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                      }}</u></h4>
                </ion-item>
                <!-- GIF Item -->
                <ion-item *ngIf="showGif && index == 0" class="ion-justify-content-center">
                  <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                  <img src="../../../assets/images/PermissioGif/fourth.gif" alt="Enable Location Guide"
                    class="location-gif">
                </ion-item>
              </ion-list>
            </div>
            <div *ngIf="selectedTabIndex == 1">
              <h2 class="font-size-18 ion-text-left inter-large color-netral-900 m-t-15 m-b-10">
                <span [innerHTML]="highlightWords('self_pwa_text.enableLocationForWebsite' |
            translate)"></span>
              </h2>
              <ion-list lines="none" class="b-r-13 m-t-5 b-1">
                <ion-item>
                  <!-- <ion-icon slot="start" name="globe-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-globe"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.openSafariWebsite' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="text-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-type"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.tapAAIcon' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-gear me-2"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.selectWebsiteSettings' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-geo-alt"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.tapLocationAllow' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="refresh-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-arrow-repeat"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.reloadPage' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item class="ion-justify-content-center">
                  <h4 (click)="toggleGif(1)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 1 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                      }}</u></h4>
                </ion-item>
                <!-- GIF Item -->
                <ion-item *ngIf="showGif && index == 1" class="ion-justify-content-center">
                  <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                  <img src="../../../assets/images/PermissioGif/fifth.gif" alt="Enable Location Guide"
                    class="location-gif">
                </ion-item>
              </ion-list>
            </div>
            <div *ngIf="selectedTabIndex == 2">
              <h2 class="font-size-18 ion-text-left inter-large color-netral-900 m-t-15 m-b-10">
                Allow Browser Location
              </h2>
              <ion-list lines="none" class="b-r-13 m-t-5 b-1">
                <ion-item>
                  <!-- <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-gear me-2"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.openSettings' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="apps-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-grid"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.click_on_apps' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="globe-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-globe"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.click_on_safari' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-geo-alt"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.click_on_location' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-geo-alt"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.allow_location_if_denied' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="refresh-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-arrow-repeat"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.reloadPage' |
                translate)"></span>
                  </ion-label>
                </ion-item>

                <ion-item class="ion-justify-content-center">
                  <h4 (click)="toggleGif(2)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 2 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                      }}</u></h4>
                </ion-item>
                <!-- GIF Item -->
                <ion-item *ngIf="showGif && index == 2" class="ion-justify-content-center">
                  <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                  <img src="../../../assets/images/PermissioGif/seven.gif" alt="Enable Location Guide"
                    class="location-gif">
                </ion-item>
              </ion-list>
            </div>
          </ng-container>

          <ng-container *ngIf="browserType === 'Chrome'">
            <div *ngIf="selectedTabIndex == 0">
              <h2 class="font-size-18 ion-text-left color-netral-900 inter-large  m-t-15 m-b-10">
                <span [innerHTML]="highlightWords('self_pwa_text.enableLocationChrome' |
                translate)"></span>
              </h2>
              <ion-list lines="none" class="b-r-13 m-t-5 b-1">
                <ion-item>
                  <!-- <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-gear me-2"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.openSettings' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-geo-alt"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.tapPrivacySecurityLocation' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <!-- <ion-icon slot="start" name="logo-chrome" class="m-r-10"></ion-icon> -->
                  <i class="bi bi-browser-chrome"></i>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.selectGoogleChrome' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-icon slot="start" name="checkmark-circle-outline" class="m-r-10"></ion-icon>
                  <ion-label class="show-fulltext color-netral-600 m-l-3">
                    <span [innerHTML]="highlightWords('self_pwa_text.chooseLocationOptionChrome' |
                translate)"></span>
                  </ion-label>
                </ion-item>
                <ion-item class="ion-justify-content-center">
                  <h4 (click)="toggleGif(1)" style="color: #295396;
    font-size: 15px;"><u>{{ (showGif && index == 1 ? 'self_pwa_text.hide_gif' : 'self_pwa_text.watch_gif') | translate
                      }}</u></h4>
                </ion-item>
                <!-- GIF Item -->
                <ion-item *ngIf="showGif && index == 1" class="ion-justify-content-center">
                  <!-- <ion-label class="show-fulltext color-netral-600 inter-regular">Follow Gif</ion-label> -->
                  <img src="../../../assets/images/PermissioGif/sixth.gif" alt="Enable Location Guide"
                    class="location-gif">
                </ion-item>
              </ion-list>
            </div>
          </ng-container>

          <ng-container *ngIf="browserType !== 'Safari' && browserType !== 'Chrome'">
            <h2 class="font-size-18 ion-text-left color-netral-900 inter-large m-t-15 m-b-10">
              <span [innerHTML]="highlightWords('self_pwa_text.enableLocationIphone' |
                translate)"></span>
            </h2>
            <ion-list lines="none" class="b-r-13 m-t-5 b-1">
              <ion-item>
                <!-- <ion-icon slot="start" name="settings-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-gear me-2"></i>
                <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">
                  <span [innerHTML]="highlightWords('self_pwa_text.openSettings' |
                translate)"></span>
                </ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="location-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-gear me-2"></i>
                <ion-label class="show-fulltext color-netral-600 m-l-3">
                  <span [innerHTML]="highlightWords('self_pwa_text.tapPrivacySecurityLocation' |
                translate)"></span>
                </ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="checkmark-circle-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-check-circle"></i>
                <ion-label class="show-fulltext color-netral-600 m-l-3">
                  <span [innerHTML]="highlightWords('self_pwa_text.ensureLocationServicesOn' |
                translate)"></span>
                </ion-label>
              </ion-item>
              <ion-item>
                <!-- <ion-icon slot="start" name="refresh-outline" class="m-r-10"></ion-icon> -->
                <i class="bi bi-arrow-repeat"></i>
                <ion-label class="show-fulltext color-netral-600 m-l-3">
                  <span [innerHTML]="highlightWords('self_pwa_text.restartDeviceIfNotWorking' |
                translate)"></span>
                </ion-label>
              </ion-item>
            </ion-list>
          </ng-container>
        </div>
        <div *ngIf="platform === 'unknown'">
          <p class="show-fulltext ion-text-left color-netral-600 inter-regular">{{'self_pwa_text.for_unknown_text' |
            translate}}
          </p>
        </div>
      </ion-card-content>
    </ion-card>
  </ion-content>
  <ion-footer *ngIf="key == 4" style="margin: auto;">
    <div fxLayout="row" fxLayoutAlign="center center" class="m-8-16">
      <ion-button expand="block"
        class="t-c commonbtn show-fulltext h-48 w-100 font-size-18 inter-medium letter-spacing-normal"
        (click)="checkNow()">
        {{'self_pwa_text.check_now' | translate}}
      </ion-button>
    </div>
  </ion-footer>
</ng-container>
<ng-template #tryAgainGuide>
  <ion-content class="modal-content" *ngIf="key == 4">
    <ion-card style="text-align: left;
    background: #f4f4f4;
    color: #111111;
    font-weight: 400;
    box-shadow: none !important;
    border-radius: 10px;
    border: 1px solid #EEEEEE;">
      <ion-card-content>
        <div fxLayout="row" fxLayoutAlign="start start" style="gap: 5px;">
          <ion-icon name="alert-circle-outline" style="zoom: 3;
          display: flex;
          color: red !important;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: -3px;"></ion-icon>
          <h4 class="font-size-15 color-netral-900">
            <span [innerHTML]="highlightWords('self_pwa_text.tried_all_steps' |
                translate)"></span>
          </h4>
        </div>
      </ion-card-content>
    </ion-card>
    <ion-card class="m-0" style="box-shadow: none;">
      <ion-card-content>
        <ion-list lines="none" class="b-r-13 m-t-5 b-1">
          <ion-item>
            <!-- <ion-icon slot="start" class="m-r-10" name="refresh-outline"></ion-icon> -->
            <i class="bi bi-arrow-repeat"></i>
            <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3">{{'self_pwa_text.you_can' |
              translate}}<span class="tryagain" (click)="tryagainpreviousstep()" class="spanarea"><u>
                  {{'self_pwa_text.try_again' |
                  translate}}</u></span> {{'self_pwa_text.previous_steps' | translate}}</ion-label>
          </ion-item>
          <ion-item>
            <!-- <ion-icon slot="start" class="m-r-10" name="refresh-outline"></ion-icon> -->
            <i class="bi bi-arrow-repeat"></i>
            <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3"><span [innerHTML]="highlightWords('self_pwa_text.try_to_refresh_page_text' |
              translate)"></span></ion-label>
          </ion-item>
          <ion-item>
            <!-- <ion-icon slot="start" class="m-r-10" name="link-outline"></ion-icon> -->
            <i class="bi bi-link-45deg"></i>
            <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3"><span [innerHTML]="highlightWords('self_pwa_text.use_different_browser' |
              translate)"></span></ion-label>
          </ion-item>
          <ion-item>
            <!-- <ion-icon slot="start" class="m-r-10" name="phone-portrait-outline"></ion-icon> -->
            <i class="bi bi-phone"></i>
            <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3"><span [innerHTML]="highlightWords('self_pwa_text.use_different_device' |
              translate)"></span></ion-label>
          </ion-item>
          <ion-item>
            <!-- <ion-icon slot="start" class="m-r-10" name="headset-outline"></ion-icon> -->
            <i class="bi bi-headset"></i>
            <ion-label class="show-fulltext color-netral-600 inter-regular m-l-3"><span [innerHTML]="highlightWords('self_pwa_text.contact_agent' |
              translate)"></span></ion-label>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>
  </ion-content>
  <ion-footer style="margin: auto;">
    <div fxLayout="row" fxLayoutAlign="center center" class="m-8-16">
      <ion-button expand="block"
        class="t-c commonbtn show-fulltext h-48 w-100 font-size-18 inter-medium letter-spacing-normal"
        (click)="Refresh()">
        {{'self_pwa_text.refresh_now' |
        translate}}
      </ion-button>
    </div>
  </ion-footer>
</ng-template>